import Vue from '../../../../../assets/vendor/vue/dist/vue.min';
import VueUploadComponent from '../../../../../assets/vendor/vue-upload-component/dist/vue-upload-component';

Vue.component('file-upload', VueUploadComponent);
if(document.querySelectorAll('#chunked-upload').length){

    new Vue({
        el: '#chunked-upload',
        data: function () {
            return {
                files: []
            }
        },
        components: {
            FileUpload: VueUploadComponent
        },
        methods: {
            /**
             * Has changed
             * @param  Object|undefined   newFile   Read only
             * @param  Object|undefined   oldFile   Read only
             * @return undefined
             */
            inputFile: function (newFile, oldFile) {
                if (newFile && oldFile && !newFile.active && oldFile.active && newFile.response.status == "success") {
                    // Upload was succesful
                    newFile.filePath = newFile.response.filePath;
                }

                // if we have a new file we automaticly trigger the upload
                if (Boolean(newFile) !== Boolean(oldFile) || oldFile.error !== newFile.error) {
                    if (!this.$refs.upload.active) {
                        this.$refs.upload.active = true
                    }
                }
            },
            /**
             * Pretreatment
             * @param  Object|undefined   newFile   Read and write
             * @param  Object|undefined   oldFile   Read only
             * @param  Function           prevent   Prevent changing
             * @return undefined
             */
            inputFilter: function (newFile, oldFile, prevent) {
                // if we don't have a new file we do nothing
                if(! newFile) {
                    return;
                }

                // Create a blob field
                newFile.blob = ''
                let URL = window.URL || window.webkitURL
                if (URL && URL.createObjectURL) {
                    newFile.blob = URL.createObjectURL(newFile.file)
                }
            },
            /**
             * Remove an existing file
             * @param file
             */
            remove(file) {
                this.$refs.upload.remove(file)
            }
        }
    });
}